import { combineReducers } from "redux";
import resultsReducer from "./resultsReducer";

const reducers = combineReducers({
    results: resultsReducer,
});

export default reducers;
